import { computed, ref, watch } from 'vue';
import { useStore } from 'vuex';
import { getBrowserStorage, loadTableScale, saveTableScale, TABLE_SCALE_DEFAULT } from './tableScale.mjs';

export function useUserTableScale(tableId) {
  const store = useStore();
  const storage = getBrowserStorage();
  const userId = computed(() => store.state.user?.user?.id);
  const scale = ref(TABLE_SCALE_DEFAULT);
  watch(userId, (value) => { scale.value = loadTableScale(storage, value, tableId); }, { immediate: true });
  watch(scale, (value) => { scale.value = saveTableScale(storage, userId.value, tableId, value); });
  const resetScale = () => { scale.value = TABLE_SCALE_DEFAULT; };
  return { scale, resetScale };
}
